import { Outlet, useOutlet } from "react-router-dom";

import FactoryTable from "./FactoryTable";

const Dashboard = () => {
  const hasChildRoute = useOutlet() !== null;

  return (
    <>
      {!hasChildRoute && <FactoryTable />}
      <Outlet />
    </>
  );
};

export default Dashboard;
